import { profileTypes } from '../types/profile'

const initialState = {
  bankSettingsSuccess: {},

  verifyBankSettingsLoading: false,
  verifyBankSettingsSuccess: {},
  verifyBankSettingsFailure: false,

  updateNextOfKinSettingsLoading: false,
  updateNextOfKinSettingsSuccess: {},
  updateNextOfKinSettingsFailure: false,
  createPin: [],
  getNextOfKinSettingsLoading: false,
  getNextOfKinSettingsSuccess: [],
  getNextOfKinSettingsFailure: false,

  updateProfileSettingsLoading: false,
  updateProfileSettingsSuccess: {},
  updateProfileSettingsFailure: false,

  updatePasswordSettingsLoading: false,
  updatePasswordSettingsSuccess: {},
  updatePasswordSettingsFailure: false,

  updatePinSettingsLoading: false,
  updatePinSettingsSuccess: {},
  updatePinSettingsFailure: false,

  updateAvatarSettingsLoading: false,
  updateAvatarSettingsSuccess: {},
  updateAvatarSettingsFailure: false,
}

export const profileReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case profileTypes.CREATE_PIN_SUCCESS:
      return {
        ...state,
        loading: false,
        createPin: action.payload,
      }
    case profileTypes.CREATE_PIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      }

    case profileTypes.UPDATE_PROFILE_LOADING:
      return {
        ...state,
        updateProfileSettingsLoading: true,
      }

    case profileTypes.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        updateProfileSettingsSuccess: action.payload,
        updateProfileSettingsLoading: false,
      }

    case profileTypes.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        updateProfileSettingsFailure: action.payload,
        updateProfileSettingsLoading: false,
      }
    case profileTypes.UPDATE_NEXT_OF_KIN_LOADING:
      return {
        ...state,
        updateNextOfKinSettingsLoading: true,
      }

    case profileTypes.UPDATE_NEXT_OF_KIN_SUCCESS:
      return {
        ...state,
        updateNextOfKinSettingsSuccess: action.payload,
        updateNextOfKinSettingsLoading: false,
      }

    case profileTypes.UPDATE_NEXT_OF_KIN_FAILURE:
      return {
        ...state,
        updateNextOfKinSettingsFailure: action.payload,
        updateNextOfKinSettingsLoading: false,
      }

    case profileTypes.GET_NEXT_OF_KIN_LOADING:
      return {
        ...state,
        getNextOfKinSettingsLoading: true,
      }

    case profileTypes.GET_NEXT_OF_KIN_SUCCESS:
      return {
        ...state,
        getNextOfKinSettingsSuccess: action.payload,
        getNextOfKinSettingsLoading: false,
      }

    case profileTypes.GET_NEXT_OF_KIN_FAILURE:
      return {
        ...state,
        getNextOfKinSettingsFailure: action.payload,
        getNextOfKinSettingsLoading: false,
      }
    case profileTypes.UPDATE_AVATAR_LOADING:
      return {
        ...state,
        updateAvatarSettingsLoading: true,
      }

    case profileTypes.UPDATE_AVATAR_SUCCESS:
      return {
        ...state,
        updateAvatarSettingsSuccess: action.payload,
        updateAvatarSettingsLoading: false,
      }

    case profileTypes.UPDATE_AVATAR_FAILURE:
      return {
        ...state,
        updateAvatarSettingsFailure: action.payload,
        updateAvatarSettingsLoading: false,
      }

    case profileTypes.UPDATE_PASSWORD_LOADING:
      return {
        ...state,
        updatePasswordSettingsLoading: true,
      }

    case profileTypes.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePasswordSettingsSuccess: action.payload,
        updatePasswordSettingsLoading: false,
      }

    case profileTypes.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        updatePasswordSettingsFailure: action.payload,
        updatePasswordSettingsLoading: false,
      }
    case profileTypes.UPDATE_PIN_LOADING:
      return {
        ...state,
        updatePinSettingsLoading: true,
      }

    case profileTypes.UPDATE_PIN_SUCCESS:
      return {
        ...state,
        updatePinSettingsSuccess: action.payload,
        updatePinSettingsLoading: false,
      }

    case profileTypes.UPDATE_PIN_FAILURE:
      return {
        ...state,
        updatePinSettingsFailure: action.payload,
        updatePinSettingsLoading: false,
      }
    default:
      return state
  }
}
